export const TITLE = 'По техническим причинам форма обратной связи недоступна';
